import * as React from 'react';

import ExtendsContextMenuItem from './ExtendsContextMenuItem';

import { withModal } from 'components/modal/ModalHOC';
import BulkMessageModal from 'modules/messenger/components/bulk-message-modal/BulkMessageModal';

import type { ContextMenuItem } from 'types';

type Props = {
  item: ContextMenuItem,
  onModalClosed?: (a: React.MouseEvent) => void
};

class ContextMenuItemBulkMessage extends ExtendsContextMenuItem<Props> {
  render() {
    const { item, onModalClosed } = this.props;
    const campaignId = item.meta ? item.meta.campaignId : {};

    const DivWithModal = withModal(<span />, {
      modalContent: BulkMessageModal,
      onModalClosed
    });

    return (
      <DivWithModal
        modalContentProps={{ campaignId }}
      >
        {this.renderIcon(item)}
        <div className="context-menu-item__text">
          {item.text}
        </div>
      </DivWithModal>
    );
  }
}

export default ContextMenuItemBulkMessage;
